import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FilterToggleOption {
  key: string;
  label: string;
  class: string;
}

@Component({
  selector: 'filter-toggle-group',
  templateUrl: './filter-toggle-group.component.html',
})
export class FilterToggleGroupComponent {
  @Input() label: string;
  @Input() options: FilterToggleOption[] = [];
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  public isActive(btnKey: string): boolean {
    return this.value === btnKey || (!this.value && btnKey === '');
  }

  public onSelect(key: string): void {
    this.valueChange.emit(key);
  }
}
